import type { Vault } from '@/types/vault'

export function isVaultInTags(vault: Vault, tags: string[]): boolean {
  if (tags.length === 0) return true
  if (!vault.tags) return false
  return tags.some((tag) => vault.tags.includes(tag))
}
